const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/insights/sir/$sirInsightId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
const paramsSchema = z.object({
  sirInsightId: z.string()
});
const sirInsightDetailsSearchSchema = itemPanelSearchSchema.extend({
  recommendation: z.string().optional()
});
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/insights/sir/$sirInsightId')({
  params: paramsSchema,
  validateSearch: zodValidator(sirInsightDetailsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});